import { createCable } from "@anycable/web";

export default createCable;
